var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import { Alert, Box, Button, CircularProgress, Grid, IconButton, Stack, TextField, Tooltip, Typography, } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import FolderZipOutlinedIcon from "@mui/icons-material/FolderZipOutlined";
import RefreshIcon from "@mui/icons-material/Refresh";
import ReplayIcon from "@mui/icons-material/Replay";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { useDataProvider, useNotify, useTranslate } from "react-admin";
import BatchPreview from "./BatchPreview";
import BatchProgress, { isActiveStatus, isTerminalStatus, } from "./BatchProgress";
import StagePanel from "./StagePanel";
import BulkGenerationQuota from "./BulkGenerationQuota";
var MAX_ARCHIVE_SIZE = 2 * 1024 * 1024 * 1024;
var POLL_INTERVAL = 3000;
var BatchOperation = function (_a) {
    var _b;
    var isActive = _a.isActive, refreshKey = _a.refreshKey, onActiveStageChange = _a.onActiveStageChange, resumedBatch = _a.resumedBatch, resumedReportJob = _a.resumedReportJob, onQuotaChange = _a.onQuotaChange, _c = _a.remainingQuota, remainingQuota = _c === void 0 ? null : _c, _d = _a.quotaLoading, quotaLoading = _d === void 0 ? false : _d;
    var dataProvider = useDataProvider();
    var notify = useNotify();
    var translate = useTranslate();
    var _e = useState(""), batchName = _e[0], setBatchName = _e[1];
    var _f = useState(null), selectedFile = _f[0], setSelectedFile = _f[1];
    var _g = useState(false), isUploading = _g[0], setIsUploading = _g[1];
    var _h = useState(false), isGenerating = _h[0], setIsGenerating = _h[1];
    var _j = useState(false), isRetrying = _j[0], setIsRetrying = _j[1];
    var _k = useState(false), isDownloadingReports = _k[0], setIsDownloadingReports = _k[1];
    var _l = useState(null), batch = _l[0], setBatch = _l[1];
    var _m = useState(null), reportJob = _m[0], setReportJob = _m[1];
    var _o = useState(0), previewRefreshKey = _o[0], setPreviewRefreshKey = _o[1];
    var _p = useState(0), activeStage = _p[0], setActiveStage = _p[1];
    useEffect(function () {
        onActiveStageChange === null || onActiveStageChange === void 0 ? void 0 : onActiveStageChange(activeStage);
    }, [activeStage, onActiveStageChange]);
    useEffect(function () {
        if (!resumedBatch || !resumedReportJob)
            return;
        setBatch(resumedBatch);
        setReportJob(resumedReportJob);
        setBatchName("");
        setSelectedFile(null);
        setPreviewRefreshKey(0);
        setIsUploading(false);
        setIsGenerating(false);
        setIsRetrying(false);
        setIsDownloadingReports(false);
        setActiveStage(2);
    }, [resumedBatch, resumedReportJob]);
    var onDrop = useCallback(function (acceptedFiles, rejectedFiles) {
        rejectedFiles.forEach(function (file) {
            file.errors.forEach(function (error) {
                if (error.code === "file-too-large") {
                    notify(translate("pages.bulkGeneration.notify.tooLarge"), { type: "error" });
                }
                else if (error.code === "file-invalid-type") {
                    notify(translate("pages.bulkGeneration.notify.invalidType"), { type: "error" });
                }
            });
        });
        if (acceptedFiles.length > 0)
            setSelectedFile(acceptedFiles[0]);
    }, [notify, translate]);
    var _q = useDropzone({
        onDrop: onDrop,
        accept: {
            "application/zip": [".zip"],
            "application/x-zip-compressed": [".zip"],
        },
        maxFiles: 1,
        maxSize: MAX_ARCHIVE_SIZE,
        multiple: false,
        noClick: Boolean(selectedFile),
        noKeyboard: Boolean(selectedFile),
    }), getRootProps = _q.getRootProps, getInputProps = _q.getInputProps, isDragActive = _q.isDragActive, openFileDialog = _q.open;
    useEffect(function () {
        if (!(batch === null || batch === void 0 ? void 0 : batch.id) || !isActiveStatus(batch.import_status))
            return;
        var timer = window.setInterval(function () {
            dataProvider.getBatch(batch.id).then(function (response) {
                setBatch(response.data);
                if (isTerminalStatus(response.data.import_status)) {
                    setPreviewRefreshKey(function (value) { return value + 1; });
                    setActiveStage(1);
                }
            });
        }, POLL_INTERVAL);
        return function () { return window.clearInterval(timer); };
    }, [batch === null || batch === void 0 ? void 0 : batch.id, batch === null || batch === void 0 ? void 0 : batch.import_status, dataProvider]);
    useEffect(function () {
        if (!(reportJob === null || reportJob === void 0 ? void 0 : reportJob.id) || !isActiveStatus(reportJob.status))
            return;
        var timer = window.setInterval(function () {
            dataProvider.getReportJob(reportJob.id).then(function (response) {
                setReportJob(response.data);
                if (isTerminalStatus(response.data.status)) {
                    void (onQuotaChange === null || onQuotaChange === void 0 ? void 0 : onQuotaChange());
                }
            });
        }, POLL_INTERVAL);
        return function () { return window.clearInterval(timer); };
    }, [dataProvider, onQuotaChange, reportJob === null || reportJob === void 0 ? void 0 : reportJob.id, reportJob === null || reportJob === void 0 ? void 0 : reportJob.status]);
    useEffect(function () {
        if (!isActive)
            return;
        var refresh = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, _a, response, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, (onQuotaChange === null || onQuotaChange === void 0 ? void 0 : onQuotaChange())];
                    case 1:
                        _c.sent();
                        if (!(batch === null || batch === void 0 ? void 0 : batch.id)) return [3 /*break*/, 5];
                        _c.label = 2;
                    case 2:
                        _c.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, dataProvider.getBatch(batch.id)];
                    case 3:
                        response = _c.sent();
                        setBatch(response.data);
                        if (isTerminalStatus(response.data.import_status)) {
                            setPreviewRefreshKey(function (value) { return value + 1; });
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        _a = _c.sent();
                        return [3 /*break*/, 5];
                    case 5:
                        if (!(reportJob === null || reportJob === void 0 ? void 0 : reportJob.id)) return [3 /*break*/, 9];
                        _c.label = 6;
                    case 6:
                        _c.trys.push([6, 8, , 9]);
                        return [4 /*yield*/, dataProvider.getReportJob(reportJob.id)];
                    case 7:
                        response = _c.sent();
                        setReportJob(response.data);
                        return [3 /*break*/, 9];
                    case 8:
                        _b = _c.sent();
                        return [3 /*break*/, 9];
                    case 9: return [2 /*return*/];
                }
            });
        }); };
        void refresh();
    }, [isActive, refreshKey]);
    var handleUpload = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!selectedFile) {
                        notify(translate("pages.bulkGeneration.notify.selectFile"), { type: "error" });
                        return [2 /*return*/];
                    }
                    setIsUploading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, dataProvider.uploadBatch("batches", {
                            data: {
                                file: selectedFile,
                                name: batchName.trim() || undefined,
                            },
                        })];
                case 2:
                    response = _b.sent();
                    setBatch(response.data);
                    setReportJob(null);
                    setSelectedFile(null);
                    setBatchName("");
                    notify(translate("pages.bulkGeneration.notify.uploaded"), { type: "success" });
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _b.sent();
                    notify(((_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.body) === null || _a === void 0 ? void 0 : _a.message) ||
                        (error_1 === null || error_1 === void 0 ? void 0 : error_1.message) ||
                        translate("pages.bulkGeneration.notify.uploadFailed"), { type: "error" });
                    return [3 /*break*/, 5];
                case 4:
                    setIsUploading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleGenerate = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!batch)
                        return [2 /*return*/];
                    setIsGenerating(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, dataProvider.createBatchReport(batch.id)];
                case 2:
                    response = _b.sent();
                    setReportJob(response.data);
                    setActiveStage(2);
                    return [4 /*yield*/, (onQuotaChange === null || onQuotaChange === void 0 ? void 0 : onQuotaChange())];
                case 3:
                    _b.sent();
                    notify(translate("pages.bulkGeneration.notify.reportQueued"), {
                        type: "success",
                    });
                    return [3 /*break*/, 6];
                case 4:
                    error_2 = _b.sent();
                    notify(((_a = error_2 === null || error_2 === void 0 ? void 0 : error_2.body) === null || _a === void 0 ? void 0 : _a.message) ||
                        (error_2 === null || error_2 === void 0 ? void 0 : error_2.message) ||
                        translate("pages.bulkGeneration.notify.reportFailed"), { type: "error" });
                    return [3 /*break*/, 6];
                case 5:
                    setIsGenerating(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleRetryImport = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!batch)
                        return [2 /*return*/];
                    setIsRetrying(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, dataProvider.retryBatchImport(batch.id)];
                case 2:
                    response = _a.sent();
                    setBatch(response.data);
                    return [3 /*break*/, 5];
                case 3:
                    error_3 = _a.sent();
                    notify((error_3 === null || error_3 === void 0 ? void 0 : error_3.message) || translate("pages.bulkGeneration.notify.retryFailed"), {
                        type: "error",
                    });
                    return [3 /*break*/, 5];
                case 4:
                    setIsRetrying(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleRetryReports = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!reportJob)
                        return [2 /*return*/];
                    setIsRetrying(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, dataProvider.retryReportTasks(reportJob.id)];
                case 2:
                    response = _a.sent();
                    setReportJob(response.data);
                    return [4 /*yield*/, (onQuotaChange === null || onQuotaChange === void 0 ? void 0 : onQuotaChange())];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 4:
                    error_4 = _a.sent();
                    notify((error_4 === null || error_4 === void 0 ? void 0 : error_4.message) || translate("pages.bulkGeneration.notify.retryFailed"), {
                        type: "error",
                    });
                    return [3 /*break*/, 6];
                case 5:
                    setIsRetrying(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleDownloadReports = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!batch)
                        return [2 /*return*/];
                    setIsDownloadingReports(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, dataProvider.downloadBatchReports(batch.id, "".concat(batch.name, "-reports.zip"))];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3:
                    error_5 = _a.sent();
                    notify((error_5 === null || error_5 === void 0 ? void 0 : error_5.message) ||
                        translate("pages.bulkGeneration.notify.reportDownloadFailed"), { type: "error" });
                    return [3 /*break*/, 5];
                case 4:
                    setIsDownloadingReports(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleBackToUpload = function () {
        setActiveStage(0);
        setBatch(null);
        setReportJob(null);
        setBatchName("");
        setSelectedFile(null);
        setPreviewRefreshKey(0);
        setIsUploading(false);
        setIsGenerating(false);
        setIsRetrying(false);
        setIsDownloadingReports(false);
    };
    var importReady = (batch === null || batch === void 0 ? void 0 : batch.import_status) === "COMPLETED" ||
        (batch === null || batch === void 0 ? void 0 : batch.import_status) === "COMPLETED_WITH_ERRORS";
    var reportComplete = Boolean(reportJob && isTerminalStatus(reportJob.status));
    var hasSuccessfulReports = ((_b = reportJob === null || reportJob === void 0 ? void 0 : reportJob.success_tasks) !== null && _b !== void 0 ? _b : 0) > 0;
    var hasFailedReports = Boolean(reportJob === null || reportJob === void 0 ? void 0 : reportJob.failed_tasks) && reportComplete;
    var regenerateFailedReportsButton = (_jsx(Button, { variant: "outlined", color: "warning", onClick: handleRetryReports, disabled: isRetrying || isGenerating, startIcon: isRetrying ? _jsx(CircularProgress, { size: 16 }) : _jsx(RefreshIcon, {}), children: translate("pages.bulkGeneration.actions.regenerateFailedReports") }));
    var backButton = function () { return (_jsx(Button, { variant: "outlined", startIcon: _jsx(ArrowBackIcon, {}), onClick: handleBackToUpload, children: translate("pages.bulkGeneration.actions.backToUpload") })); };
    var stageActions = function (actions) { return (_jsx(Stack, { direction: "row", justifyContent: "flex-end", spacing: 1.5, flexWrap: "wrap", children: actions })); };
    return (_jsxs(Grid, { container: true, spacing: 2.5, children: [_jsx(Grid, { item: true, xs: 12, children: _jsx(BatchProgress, { batch: batch, reportJob: reportJob, activeStage: activeStage, onStageChange: setActiveStage }) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(BulkGenerationQuota, { remainingQuota: remainingQuota, loading: quotaLoading }) }), activeStage === 0 && (_jsx(Grid, { item: true, xs: 12, children: _jsxs(StagePanel, { title: translate("pages.bulkGeneration.stages.upload"), footer: stageActions(_jsx(Button, { variant: "contained", disabled: !selectedFile || isUploading, onClick: handleUpload, startIcon: isUploading ? _jsx(CircularProgress, { size: 18, color: "inherit" }) : _jsx(UploadFileIcon, {}), children: isUploading
                            ? translate("pages.bulkGeneration.actions.uploading")
                            : translate("pages.bulkGeneration.actions.upload") })), children: [_jsx(TextField, { fullWidth: true, label: translate("pages.bulkGeneration.fields.name"), value: batchName, onChange: function (event) { return setBatchName(event.target.value); }, inputProps: { maxLength: 255 }, disabled: isUploading }), _jsxs(Box, __assign({}, getRootProps(), { sx: {
                                mt: 2,
                                p: 3,
                                border: "2px dashed",
                                borderColor: isDragActive ? "primary.main" : "grey.400",
                                borderRadius: 1,
                                textAlign: "center",
                                cursor: selectedFile ? "default" : "pointer",
                                backgroundColor: isDragActive ? "action.hover" : "background.paper",
                                transition: "border-color 0.2s ease, background-color 0.2s ease",
                            }, children: [_jsx("input", __assign({}, getInputProps())), _jsx(UploadFileIcon, { color: "primary", sx: { fontSize: 40, mb: 1 } }), _jsx(Typography, { fontWeight: 600, children: translate("pages.bulkGeneration.dropzone.prompt") }), _jsx(Typography, { variant: "body2", color: "text.secondary", mt: 0.5, children: translate("pages.bulkGeneration.dropzone.hint") }), selectedFile && (_jsxs(Stack, { direction: "row", justifyContent: "center", alignItems: "center", spacing: 1, mt: 2, children: [_jsxs(Typography, { variant: "body2", children: [selectedFile.name, " (", (selectedFile.size / 1024 / 1024).toFixed(1), " MB)"] }), _jsx(Tooltip, { title: translate("pages.bulkGeneration.actions.replace"), children: _jsx(IconButton, { size: "small", onClick: openFileDialog, disabled: isUploading, children: _jsx(ReplayIcon, {}) }) }), _jsx(Tooltip, { title: translate("pages.bulkGeneration.actions.remove"), children: _jsx(IconButton, { size: "small", color: "error", onClick: function () { return setSelectedFile(null); }, disabled: isUploading, children: _jsx(DeleteOutlineIcon, {}) }) })] }))] })), batch && !isTerminalStatus(batch.import_status) && (_jsx(Alert, { severity: "info", sx: { mt: 2 }, children: translate("pages.bulkGeneration.progress.importing") })), (batch === null || batch === void 0 ? void 0 : batch.import_status) === "FAILED" && (_jsx(Stack, { direction: "row", justifyContent: "flex-end", mt: 2, children: _jsx(Button, { variant: "outlined", startIcon: isRetrying ? _jsx(CircularProgress, { size: 18 }) : _jsx(RefreshIcon, {}), onClick: handleRetryImport, disabled: isRetrying, children: translate("pages.bulkGeneration.actions.retryImport") }) }))] }) })), activeStage === 1 && batch && isTerminalStatus(batch.import_status) && (_jsx(Grid, { item: true, xs: 12, children: _jsx(StagePanel, { title: translate("pages.bulkGeneration.stages.preview"), footer: stageActions(_jsxs(_Fragment, { children: [backButton(), importReady && (_jsx(Button, { variant: "contained", onClick: handleGenerate, disabled: isGenerating, startIcon: isGenerating && _jsx(CircularProgress, { size: 18, color: "inherit" }), children: translate("pages.bulkGeneration.actions.confirmGenerate") }))] })), children: _jsx(BatchPreview, { batchId: batch.id, refreshKey: previewRefreshKey, onQuotaChange: onQuotaChange }) }) })), activeStage === 2 && importReady && (_jsx(Grid, { item: true, xs: 12, children: _jsxs(StagePanel, { title: translate("pages.bulkGeneration.stages.generate"), footer: stageActions(_jsxs(_Fragment, { children: [backButton(), reportComplete ? (_jsxs(_Fragment, { children: [hasFailedReports && regenerateFailedReportsButton, hasSuccessfulReports && (_jsx(Button, { variant: "contained", startIcon: isDownloadingReports
                                            ? _jsx(CircularProgress, { size: 16, color: "inherit" })
                                            : _jsx(FolderZipOutlinedIcon, {}), onClick: handleDownloadReports, disabled: isDownloadingReports, children: translate("pages.bulkGeneration.actions.downloadReports") }))] })) : (_jsxs(_Fragment, { children: [hasFailedReports && regenerateFailedReportsButton, _jsx(Button, { variant: "contained", onClick: handleGenerate, disabled: isGenerating || isActiveStatus(reportJob === null || reportJob === void 0 ? void 0 : reportJob.status), startIcon: isGenerating
                                            ? _jsx(CircularProgress, { size: 18, color: "inherit" })
                                            : reportJob
                                                ? _jsx(RestartAltIcon, {})
                                                : undefined, children: translate(reportJob
                                            ? "pages.bulkGeneration.actions.regenerateBatch"
                                            : "pages.bulkGeneration.actions.generate") })] }))] })), children: [reportJob && isActiveStatus(reportJob.status) && (_jsx(Alert, { severity: "info", children: translate("pages.bulkGeneration.progress.generating") })), reportComplete && !hasSuccessfulReports && (_jsx(Alert, { severity: "warning", sx: { mt: 2 }, children: translate("pages.bulkGeneration.progress.noSuccessfulReports") }))] }) }))] }));
};
export default BatchOperation;
